import { Link } from "react-router-dom";
import { MapPin, Lock, ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/Motion";
import { DeadlineChip } from "@/components/Tiers";
import { WinnerBadges } from "@/components/WinnerBadge";
import { SampleBadge } from "@/components/SampleBadge";

export const BriefCard = ({ b, i = 0 }) => (
  <Reveal delay={(i % 3) * 0.06}>
    <Link to={`/briefs/${b.id}`} className="group block h-full overflow-hidden rounded-2xl border border-[#2A1240]/10 bg-[#FFFFFF] hover:border-[#E0218A]/40 transition-colors" data-testid={`brief-card-${b.id}`}>
      <div className="relative aspect-[16/9] overflow-hidden bg-[#FBE9F3]">
        <img src={b.cover_image || "/img/gala.jpg"} alt={b.title} className="h-full w-full object-cover opacity-70 group-hover:scale-105 transition-transform duration-[1400ms]" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#FFFFFF] to-transparent" />
        <div className="absolute left-5 bottom-4 right-5">
          <p className="text-[11px] uppercase tracking-[0.28em] text-[#8E2BC4] flex items-center gap-2"><SampleBadge show={b.sample} testid={`brief-sample-${b.id}`} />{b.org_name}</p>
          <p className="mt-1 font-display text-2xl text-[#2A1240]">{b.title}</p>
        </div>
        {b.locked && <span className="absolute top-4 right-4 inline-flex items-center gap-1 rounded-full bg-[#FFF7FB]/80 px-3 py-1 text-[11px] text-slate-200"><Lock className="h-3 w-3" />NDA</span>}
        <div className="absolute top-4 left-4"><WinnerBadges companyId={b.company_id} size="sm" testid={`brief-card-badge-${b.id}`} /></div>
      </div>
      <div className="p-5">
        <p className="text-sm text-slate-300">Looking for <span className="text-[#2A1240]">{b.looking_for || "partners"}</span></p>
        <div className="mt-4 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs text-slate-300">
          {b.location && <span className="flex items-center gap-1"><MapPin className="h-3 w-3 text-[#E0218A]" />{b.location}</span>}
          {b.expected_reach && <span>Reach {b.expected_reach}</span>}
          {b.value_range && <span className="font-mono text-[#8E2BC4]">{b.value_range}</span>}
          <DeadlineChip date={b.deadline} />
          <ArrowUpRight className="ml-auto h-4 w-4 text-slate-400 group-hover:text-[#E0218A] transition-colors" />
        </div>
      </div>
    </Link>
  </Reveal>
);
